import { toFixedTrimTrailing } from './Number.utils';

export function formatDataCap(dataCapGB: number) {
  if (dataCapGB >= 1024) {
    return `${toFixedTrimTrailing(dataCapGB / 1024, 1)} TB`;
  }
  return `${dataCapGB} GB`;
}
